<script setup lang="ts">
import { useI18n } from 'vue-i18n'

import BaseButton from '@/components/ui/BaseButton.vue'
import BaseModal from '@/components/ui/BaseModal.vue'
import { useUiStore } from '@/stores/ui'

/**
 * A single mounted dialog driven by the UI store, so any component can ask for
 * confirmation with `await ui.confirm(...)` instead of managing its own modal.
 */
const ui = useUiStore()
const { t } = useI18n()
</script>

<template>
  <BaseModal
    :open="!!ui.confirmRequest"
    :title="ui.confirmRequest?.title"
    size="sm"
    :close-on-backdrop="false"
    @close="ui.resolveConfirm(false)"
  >
    <p v-if="ui.confirmRequest?.body" class="text-sm text-gray-600 dark:text-neutral-300">
      {{ ui.confirmRequest.body }}
    </p>

    <template #footer>
      <BaseButton variant="secondary" @click="ui.resolveConfirm(false)">
        {{ ui.confirmRequest?.cancelLabel || t('common.cancel') }}
      </BaseButton>
      <BaseButton
        :variant="ui.confirmRequest?.variant === 'danger' ? 'danger' : 'primary'"
        :icon="ui.confirmRequest?.variant === 'danger' ? 'trash' : 'check'"
        @click="ui.resolveConfirm(true)"
      >
        {{ ui.confirmRequest?.confirmLabel || t('common.confirm') }}
      </BaseButton>
    </template>
  </BaseModal>
</template>
